import { useTheme } from '../../ThemeContext';

export default function FormInput({
  type = 'text',
  value,
  onChange,
  placeholder,
  borderColor,
  disabled,
  id,
  ...rest
}) {
  const { t } = useTheme();
  const effectiveBorder = borderColor || t.borderStrong;

  return (
    <input
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      id={id}
      style={{
        width: '100%',
        padding: '12px 16px',
        border: `1px solid ${effectiveBorder}`,
        borderRadius: '8px',
        fontSize: '14px',
        fontFamily: 'Poppins, sans-serif',
        backgroundColor: t.surface,
        color: t.text,
        outline: 'none',
        boxSizing: 'border-box',
      }}
      onFocus={(e) => {
        if (!borderColor) e.target.style.borderColor = t.accent;
      }}
      onBlur={(e) => {
        if (!borderColor) e.target.style.borderColor = t.borderStrong;
      }}
      {...rest}
    />
  );
}
